import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { API_URL } from '../config';
import Header from '../components/Header/Header';
import SideBar from '../components/SideBar/SideBar';
import ServicesContent from '../components/ServicesContent/ServicesContent';
import OfficeMap from '../components/OfficeMap/OfficeMap';
import { SINGLE_OFFICE_MODE } from '../config';
import { getCommonData } from '../components/Main/actions';
import { getServices, getOfficeInfo, singleOfficePending, singleOfficeFulfiled, singleOfficeFailure } from '../components/ServicesContent/actions';
import { intervalsResetData } from '../components/IntervalsContent/actions';
import { getOffices } from '../components/OfficesContent/actions';
import { toggleStatsModal, } from '../components/Stats/actions';


class ServicesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      officeId: '',
    }

    this.singleOfficeInit = this.singleOfficeInit.bind(this);
  }

  componentDidMount() {
    document.title = 'Výběr služby';

    if (this.props.servicesCommon.status === false) 
      this.props.getCommonData();

    if (SINGLE_OFFICE_MODE) {
      this.singleOfficeInit();
    }
    else {
      const officeId = this.props.params.officeId;

      this.props.getServices(officeId);
      this.props.getOfficeInfo(officeId);
      this.setState({
        officeId: officeId,
      });
    }
    this.props.intervalsResetData();

    const openStats = this.props.params.stats;
    if (openStats !== undefined && openStats === 'true') {
      this.props.toggleStatsModal(null);
    }
  }

  singleOfficeInit() {
    this.props.singleOfficePending();
    axios.get(`${API_URL}/web/stores`)
      .then((response) => {
        if (response.data.data.length > 0 && !!response.data.data[0].id) {
          const { id, } = response.data.data[0];
          this.setState({
            officeId: id.toString(),
          });
          this.props.getServices(id);
          this.props.getOfficeInfo(id);
          this.props.singleOfficeFulfiled();
        }
        else {
          this.props.singleOfficeFailure();
        }
      })
      .catch((error) => {
        this.props.singleOfficeFailure();
      });
  }

  render() {
    const { servicesData, officeData, servicesCommon, previousSteps, sideBarTitles, logo, btnBackTitle } = this.props;
    const { officeId } = this.state;

    return (
      <div>
        <Header
          logoName={logo.fileName}
          office={officeId}
        /> 

        <SideBar
          activePage={1}
          officeId=''
          serviceId=''
          intervalId=''
          titleOne={sideBarTitles.titleOne}
          titleTwo={sideBarTitles.titleTwo}
          titleThree={sideBarTitles.titleThree}
          titleFour={sideBarTitles.titleFour}
        />  

        <div className="container-fluid page-header page-sidebar">
        <div className="row page-row row-equal">
            <div className="col col-md-6 col-sm-12 page-col">
              <ServicesContent 
                btnBackTitle={btnBackTitle}
                servicesCommon={servicesCommon}
                servicesData={servicesData}
                previousSteps={previousSteps}
                officeData={{
                  ...officeData,
                  isLoading: SINGLE_OFFICE_MODE ? officeData.isLoading || servicesData.isLoading : officeData.isLoading
                }}
                officeId={officeId}
              />
            </div>
            <div className="col col-md-6 page-col page-col-hide-md page-col-left-border page-col-fixed">
              <OfficeMap
                isLoading={SINGLE_OFFICE_MODE ? officeData.isLoading || servicesData.isLoading : officeData.isLoading}
                status={officeData.status}
                address={officeData.data.server_address}
                name={officeData.data.pub_server_name}
                lat={officeData.data.lat}
                lng={officeData.data.lon}                           
              />     
            </div>
          </div>
        </div>     
      </div>    
    );
  }
}


const mapStateToProps = (state) => {
  const { servicesData, officeData, } = state.services;
  return { 
    servicesData, 
    officeData,
    servicesCommon: {
      status: state.main.status,
      ...state.main.data.servicesCommon,
    },
    btnBackTitle: state.main.data.officesCommon.title,
    previousSteps: state.main.data.previousSteps,
    logo: {
      ...state.main.data.logo,
    },
    sideBarTitles: {
      titleOne: state.main.data.officesCommon.title,
      titleTwo: state.main.data.servicesCommon.title,
      titleThree: state.main.data.intervalsCommon.title,
      titleFour: state.main.data.reservationCommon.title,
    }
  };
}

const mapDispatchToProps = (dispatch) => {
  return {  
    getCommonData: bindActionCreators(getCommonData, dispatch),
    getServices: bindActionCreators(getServices, dispatch),
    getOfficeInfo: bindActionCreators(getOfficeInfo, dispatch),
    getOffices: bindActionCreators(getOffices, dispatch),
    intervalsResetData: bindActionCreators(intervalsResetData, dispatch),
    singleOfficePending: bindActionCreators(singleOfficePending, dispatch),
    singleOfficeFulfiled: bindActionCreators(singleOfficeFulfiled, dispatch),
    singleOfficeFailure: bindActionCreators(singleOfficeFailure, dispatch),
    toggleStatsModal: bindActionCreators(toggleStatsModal, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicesPage);



// WEBPACK FOOTER //
// ./src/pages/Services.js